export const GET_USER_DATA = 'GET_USER_DATA';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const STORE_NOTIFICATIONS = 'STORE_NOTIFICATIONS';
export const STORE_NOTIFICATIONS_UNREAD_COUNT = 'STORE_NOTIFICATIONS_UNREAD_COUNT';

export const STORE_VISITS = 'STORE_VISITS';
export const RESET_VISITS = 'RESET_VISITS';

export const STORE_DAILY_REPORT = 'STORE_DAILY_REPORT';

export const STORE_PLANNED_VISITS = 'STORE_PLANNED_VISITS';
export const CLEAR_PLANNED_VISITS = 'CLEAR_PLANNED_VISITS';

export const STORE_ACTIVE_PLAN = 'STORE_ACTIVE_PLAN';
export const STORE_PLANS = 'STORE_PLANS';

export const STORE_WORKLOAD = 'STORE_WORKLOAD';
export const RESET_WORKLOAD = 'RESET_WORKLOAD';

export const STORE_REGIONS = 'STORE_REGIONS';
export const RESET_REGIONS = 'RESET_REGIONS';

export const STORE_ENTITIES = 'STORE_ENTITIES';
export const STORE_ALL_ENTITIES = 'STORE_ALL_ENTITIES';
export const RESET_ENTITIES = 'RESET_ENTITIES';
export const STORE_CUSTOMERS_TYPES = 'STORE_CUSTOMERS_TYPES';
export const STORE_CUSTOMERS_COUNTS_BY_TYPE = 'STORE_CUSTOMERS_COUNTS_BY_TYPE';
export const RESET_CUSTOMERS_COUNTS_BY_TYPE = 'RESET_CUSTOMERS_COUNTS_BY_TYPE';

export const STORE_MATERIALS = 'STORE_MATERIALS';
export const SPECIALTY_MATERIALS = 'SPECIALTY_MATERIALS';
export const STORE_MATERIAL_FORMS = 'STORE_MATERIAL_FORMS';
export const RESET_MATERIALS = 'RESET_MATERIALS';
export const RESET_MATERIAL_FORMS = 'RESET_MATERIAL_FORMS';

export const STORE_TRANSACTIONS_SUMMARY = 'STORE_TRANSACTIONS_SUMMARY';
export const RESET_TRANSACTIONS_SUMMARY = 'RESET_TRANSACTIONS_SUMMARY';
export const STORE_TRANSACTIONS_JOURNAL = 'STORE_TRANSACTIONS_JOURNAL';
export const RESET_TRANSACTIONS_JOURNAL = 'RESET_TRANSACTIONS_JOURNAL';
export const STORE_TEMP_TRANSACTIONS = 'STORE_TEMP_TRANSACTIONS';
export const RESET_TEMP_TRANSACTIONS = 'RESET_TEMP_TRANSACTIONS';
export const STORE_TRANSACTIONS_STATEMENT = 'STORE_TRANSACTIONS_STATEMENT';
export const RESET_TRANSACTIONS_STATEMENT = 'RESET_TRANSACTIONS_STATEMENT';

export const STORE_SPECIALTIES = 'STORE_SPECIALTIES';
export const RESET_SPECIALTIES = 'RESET_SPECIALTIES';

export const STORE_PRICE_TYPES = 'STORE_PRICE_TYPES';

export const STORE_BALANCE = 'STORE_BALANCE';
export const STORE_TARGET = 'STORE_TARGET';
export const STORE_FINANCIAL_TARGET = 'STORE_FINANCIAL_TARGET';
export const STORE_SALARY = 'STORE_SALARY';
export const STORE_LEAVES = 'STORE_LEAVES';
export const STORE_REVIEW = 'STORE_REVIEW';
export const RESET_PROFILE = 'RESET_PROFILE';

export const STORE_EXAM = 'STORE_EXAM';
export const RESET_EXAM = 'RESET_EXAM';
export const STORE_VACATION = 'STORE_VACATION';

// export const STORE_CONFIGURATION = 'STORE_CONFIGURATION';

// export const STORE_CON_TYPES = 'STORE_CON_TYPES';
// export const STORE_ROLE_EMPLOYEE = 'STORE_ROLE_EMPLOYEE';
// export const STORE_ALL_CONFIGURATION = 'STORE_ALL_CONFIGURATION';

// export const STORE_FIELDS_IN_STAFF = 'STORE_FIELDS_IN_STAFF';
// export const STORE_ROLE_IN_STAFF = 'STORE_ROLE_IN_STAFF';

export const STORE_CONFIGURATION = 'STORE_CONFIGURATION';

export const STORE_CUSTOMERS_TYPES_CONFIG = 'STORE_CUSTOMERS_TYPES_CONFIG';

export const STORE_CON_TYPES = 'STORE_CON_TYPES';

export const STORE_FIELDS_IN_STAFF = 'STORE_FIELDS_IN_STAFF';

export const STORE_ROLE_IN_STAFF = 'STORE_ROLE_IN_STAFF';

export const STORE_FIELDS_IN_CUSTOMERS = 'STORE_FIELDS_IN_CUSTOMERS';

export const STORE_TYPES_OF_CUSTOMERS = 'STORE_TYPES_OF_CUSTOMERS';

export const STORE_FIELDS_IN_MATERIALS = 'STORE_FIELDS_IN_MATERIALS';

export const STORE_FIELDS_IN_VISITS = 'STORE_FIELDS_IN_VISITS';

export const STORE_ALL_CONFIGURATION = 'STORE_ALL_CONFIGURATION';

export const STORE_ROLE_EMPLOYEE = 'STORE_ROLE_EMPLOYEE';

export const RESET = 'RESET';

export const STORE_LOCK_VISIT_AFTER_DURATION = 'STORE_LOCK_VISIT_AFTER_DURATION'

export const STORE_SERVER_TIME = 'STORE_SERVER_TIME'

export const STORE_WEEKLY_PLAN = 'STORE_WEEKLY_PLAN'

export const STORE_REGION_PLAN = 'STORE_REGION_PLAN'

export const STORE_REGION_PLANS = 'STORE_REGION_PLANS'

export const STORE_REGION_PLANS_STATISTICS = 'STORE_REGION_PLANS_STATISTICS'

export const RESET_REGION_PLANS_STATISTICS = 'RESET_REGION_PLANS_STATISTICS'

export const STORE_REAL_NUMBER_AMOUNT = 'STORE_REAL_NUMBER_AMOUNT'

export const STORE_ACTIVE_REGION_PLAN = 'STORE_ACTIVE_REGION_PLAN'

export const STORE_PLANNED_REGIONS = 'STORE_PLANNED_REGIONS'

export const CLEAR_PLANNED_REGIONS = 'CLEAR_PLANNED_REGIONS'

export const STORE_VACATIONS_DAYS_DETAILS = 'STORE_VACATIONS_DAYS_DETAILS'

export const STORE_CURRENT_TIME = 'STORE_CURRENT_TIME'

export const STORE_SYSTEM_CONFIG_VALUE = 'STORE_SYSTEM_CONFIG_VALUE'

export const LOCK_PLAN_BEFORE_DAYS = 'LOCK_PLAN_BEFORE_DAYS'

export const STORE_VISITS_CONFIG_BY_CUSTOMER_TYPE = 'STORE_VISITS_CONFIG_BY_CUSTOMER_TYPE'

export const STORE_FIELDS_IN_CUSTOMERS_TYPES_FOR_VISITS = 'STORE_FIELDS_IN_CUSTOMERS_TYPES_FOR_VISITS'

export const STORE_ACCOUNTS = 'STORE_ACCOUNTS'

export const STORE_WORK_DAYS_STATS = 'STORE_WORK_DAYS_STATS'
export const RESET_WORK_DAYS_STATS = 'RESET_WORK_DAYS_STATS'

export const STORE_QUEUE = 'STORE_QUEUE'
export const UPDATE_QUEUE_ITEM = 'UPDATE_QUEUE_ITEM'
export const REMOVE_QUEUE_ITEM = 'REMOVE_QUEUE_ITEM'
export const SET_SYNCING = 'SET_SYNCING'

export const STORE_VISIT_DRAFT_CUSTOMER = 'STORE_VISIT_DRAFT_CUSTOMER'
export const STORE_VISIT_DRAFT_PRICE_TYPE = 'STORE_VISIT_DRAFT_PRICE_TYPE'
export const STORE_VISIT_DRAFT_DURATION = 'STORE_VISIT_DRAFT_DURATION'
export const STORE_VISIT_DRAFT_INVOICE_ITEMS = 'STORE_VISIT_DRAFT_INVOICE_ITEMS'
export const STORE_VISIT_DRAFT_RETURN_ITEMS = 'STORE_VISIT_DRAFT_RETURN_ITEMS'
export const STORE_VISIT_DRAFT_ORDER_ITEMS = 'STORE_VISIT_DRAFT_ORDER_ITEMS'
export const STORE_VISIT_DRAFT_ORDER_DELIVERY_DATE = 'STORE_VISIT_DRAFT_ORDER_DELIVERY_DATE'
export const STORE_VISIT_DRAFT_ORDER_DELIVERY_TIME = 'STORE_VISIT_DRAFT_ORDER_DELIVERY_TIME'
export const STORE_VISIT_DRAFT_ORDER_DELIVERY_PLACE = 'STORE_VISIT_DRAFT_ORDER_DELIVERY_PLACE'
export const STORE_VISIT_DRAFT_MARKETING = 'STORE_VISIT_DRAFT_MARKETING'
export const STORE_VISIT_DRAFT_PAYMENTS = 'STORE_VISIT_DRAFT_PAYMENTS'
export const STORE_VISIT_DRAFT_DISCOUNT = 'STORE_VISIT_DRAFT_DISCOUNT'
export const STORE_VISIT_DRAFT_FROM_VISIT = 'STORE_VISIT_DRAFT_FROM_VISIT'
export const RESET_VISIT_DRAFT = 'RESET_VISIT_DRAFT'

export const STORE_EMPLOYEE_STOCK = 'STORE_EMPLOYEE_STOCK'
export const RESET_EMPLOYEE_STOCK = 'RESET_EMPLOYEE_STOCK'

export const STORE_DEBT_VISITS = 'STORE_DEBT_VISITS'
export const UPDATE_DEBT_VISIT_AMOUNT_RECEIVED = 'UPDATE_DEBT_VISIT_AMOUNT_RECEIVED'
export const RESET_DEBT_VISITS = 'RESET_DEBT_VISITS'